import Cookies from 'js-cookie';
import { TAG_OUT_OF_STOCK } from '../constants/product';

export const generateHash = () => {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return "_" + Math.random().toString(36).substr(2, 9);
};

export const initSelectedCar = () => {
  let submodelParsed = null;

  try {
    const submodel = localStorage.getItem('car-submodel') || Cookies.get('submodel');

    if (submodel) {
      submodelParsed = JSON.parse(submodel);
    }
  } catch (e) {
    console.error('initSelectedCar error parsing submodel e', e);
  }

  return {
    year: (localStorage.getItem('car-year') || Cookies.get('year')) || "",
    make: (localStorage.getItem('car-make') || Cookies.get('make')) || "",
    model: (localStorage.getItem('car-model') || Cookies.get('model')) || "",
    submodel: submodelParsed || "",
    option: {}
  }
};

export const formatMoney = (price) => {
  if (!price) {
    return null;
  }

  const moneyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return moneyFormatter.format(price);
}

export const getNewShopifyImageSize = ({ width = 200, height = 200, imageUrl }) => {
  if (!imageUrl?.includes('.jpg')) {
    return imageUrl;
  }

  let newImageUrl = null;

  try {
    const [url, params] = imageUrl.split('.jpg');
    newImageUrl = `${url}_${width}x${height}.jpg${params}`;
  } catch (e) {
    console.log('getNewShopifyImageSize error e', e);
    return imageUrl;
  }

  return newImageUrl;
}

export const getMinAndMaxPriceFromVariants = (variants) => {
  const min = Math.min(...variants.map(v => v.price));
  const max = Math.max(...variants.map(v => v.price));

  return [min, max];
}

export const useIsOutOfStock = (tags = []) => {
  return tags.includes(TAG_OUT_OF_STOCK);
}
